import React, { useEffect } from "react";
import Form from "react-bootstrap/Form";
import InputMask from "react-input-mask";
import { Row, Col } from "react-bootstrap";
import FormTexts from "../../../../constants/forms";
import { formsLabelType } from "../../../../enums/index";
import { ToPersianNumber } from "../../../../functions/index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NationalCodeSeparator } from "../../../../functions/index";
import {
  faCheckCircle,
  faExclamationCircle,
} from "@fortawesome/free-solid-svg-icons";
import Constants from "../../../../constants/constants";
const PartOneThirdPart = (props) => {
  return (
    <>

      <Row className="mb-2">
        <Form.Group as={Col}>
          <Form.Label className="input-label temp-text-box-label">
            {FormTexts.Labels(formsLabelType.NationalCode())}:
          </Form.Label>
          <span className="temp-text-box dir-ltr">
            {props.customer.NationalCode ? (
              NationalCodeSeparator(props.customer.NationalCode)
            ) : (
              <br />
            )}
          </span>
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label className="input-label">
            {FormTexts.Labels(formsLabelType.Name())}:
          </Form.Label>
          <Form.Control
            className="normal-input"
            type="text"
            value={props.customer.FirstName ? props.customer.FirstName : ""}
            onChange={(e) => {
              props.setCustomer({
                ...props.customer,
                FirstName: e.target.value,
              });
            }}
          />
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label className="input-label">
            {FormTexts.Labels(formsLabelType.Family())}:
          </Form.Label>
          <Form.Control
            className="normal-input"
            type="text"
            value={props.customer.LastName ? props.customer.LastName : ""}
            onChange={(e) => {
              props.setCustomer({
                ...props.customer,
                LastName: e.target.value,
              });
            }}
          />
        </Form.Group>
      </Row>
      <Row className="mb-2">
        <Form.Group as={Col}>
          <Form.Label className="input-label birthday-input-label">
            {FormTexts.Labels(formsLabelType.BirthDay())}:
          </Form.Label>
          <InputMask
            mask="9999/99/99"
            className="normal-input from-control birthday-input"
            type="text"
            defaultValue={
              props.customer.PersianBirthDate
                ? props.customer.PersianBirthDate
                : ""
            }
            onChange={(e) => {
              props.setCustomer({
                ...props.customer,
                PersianBirthDate: e.target.value,
              });
            }}
          />
        </Form.Group>
      </Row>
      <Row className="mb-2">
        <Form.Group as={Col}>
          <Form.Label className="input-label">
            {FormTexts.Labels(formsLabelType.FatherName())}:
          </Form.Label>
          <Form.Control
            className="normal-input"
            type="text"
            value={props.customer.FatherName ? props.customer.FatherName : ""}
            onChange={(e) => {
              props.setCustomer({
                ...props.customer,
                FatherName: e.target.value,
              });
            }}
          />
        </Form.Group>
      </Row>
      <Row className="mb-2 mt-5">
        <Form.Group as={Col}>
          <Form.Label className="input-label detail-text-box-label">
            {FormTexts.Labels(formsLabelType.Mobile())}:
          </Form.Label>
          <span className="detail-text-box">
            {props.customer.Mobile
              ? ToPersianNumber(props.customer.Mobile)
              : ""}
            &nbsp;&nbsp;&nbsp;
            {props.customer.MobileVerificationStatus === 1 ? (
              <FontAwesomeIcon className="verified" icon={faCheckCircle} />
            ) : props.customer.MobileVerificationStatus === 2 ? (
              <FontAwesomeIcon
                className="not verified"
                icon={faExclamationCircle}
              />
            ) : (
              ""
            )}
          </span>
        </Form.Group>
      </Row>
      <Row className="mb-2">
        <Form.Group as={Col}>
          <Form.Label className="input-label detail-text-box-label">
            {FormTexts.Labels(formsLabelType.Email())}:
          </Form.Label>
          <span className="detail-text-box">
            {props.customer.Email ? props.customer.Email : ""}&nbsp;&nbsp;&nbsp;
            {props.customer.EmailVerificationStatus === 1 ? (
              <FontAwesomeIcon className="verified" icon={faCheckCircle} />
            ) : props.customer.EmailVerificationStatus === 2 ? (
              <FontAwesomeIcon
                className="not verified"
                icon={faExclamationCircle}
              />
            ) : (
              ""
            )}
          </span>
        </Form.Group>
      </Row>
      <Row className="mb-2">
        <Form.Group as={Col}>
          <Form.Label className="input-label detail-text-box-label">
            {FormTexts.Labels(formsLabelType.Address())}:
          </Form.Label>
          <span className="detail-text-box">
             {props.customer?.State ? `${Constants.State}: ${props?.customer?.State}${Constants.Dash} ` : "----"}
             {props.customer?.City ? `${Constants.City}: ${props?.customer?.City} ${Constants.Dash} ` : "----"}
             {props.customer?.ResidenceAddress ? `${Constants.ResidenceAddress}:  ${props.customer.ResidenceAddress}${Constants.Dash} `: "----"}
             {props.customer?.Street ? `${Constants.Street}:  ${props.customer.Street} ${Constants.Dash} `: "----"}
             {props.customer?.HouseNumber ?`${Constants.HouseNumber}: ${props.customer.HouseNumber}${Constants.Dash} `: "---"}
             {props.customer?.PostalCode? `${Constants.Dash} ${Constants.PostalCode} ${Constants.AuthHistoryArray.column} ${props.customer.PostalCode}`:"---"} 
          </span>
        </Form.Group>
      </Row>
    </>
  );
};
export default PartOneThirdPart;
